import React, {useEffect, useState} from "react";
import useIsMounted from "../../../../../../../../../hooks/use-is-mounted";
import axios from "axios";
import Api from "../../../../../../../../../../core/services/api/api";
import {ReactComponent as CheckedBox} from "../../../../../../../../../../assets/images/check-box/checkbox-active.svg";
import {ReactComponent as EmptyBox} from "../../../../../../../../../../assets/images/check-box/checkbox.svg";
import {OutlinedAutoComplete} from "../../../../../../../../../components/base/auto_complete/outlined_auto_complete";
import {CircularProgress} from "@mui/material";
import Chips, {ChipsTypes} from "../../../../../../../../../components/base/chips/chips";

const NewBulkPriceChangeViewProductSelectionAutoComplete = ({
                                                                selectedItems,
                                                                setSelectedItems,
                                                                disabled,
                                                            }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [options, setOptions] = useState([]);
    const [autoCompleteText, setAutoCompleteText] = useState();
    const isMounted = useIsMounted();

    /**
     * With each change in the
     */
    useEffect(() => {
        setSelectedOptions(selectedItems.map(e => ({
            title: e.value,
            value: e,
        })));
    }, [selectedItems])

    /**
     * Listens for the changes in autoCompleteText and with each change, if the length of the autoComplete text is
     * more than 0, then fetches the parts for the shopping cart.
     */
    useEffect(() => {
        if (!isMounted())
            return;
        if (!autoCompleteText?.length || autoCompleteText?.length < 3)
            return;
        const axiosCancelToken = axios.CancelToken.source();
        let timer = getAutoCompleteItems(autoCompleteText, axiosCancelToken);
        return () => {
            if (timer) clearTimeout(timer);
            else axiosCancelToken.cancel();
        }
    }, [autoCompleteText])

    /**
     * creates a time-out function for getting the auto complete suggestions
     * @param {string} autoCompleteText
     * @param {import('axios').CancelTokenSource} axiosCancelToken
     * @return {number}
     */
    const getAutoCompleteItems = (autoCompleteText, axiosCancelToken) => {
        return setTimeout(() => {
            if (!isMounted())
                return;
            if (!autoCompleteText?.length || autoCompleteText?.length < 3) return;
            getData(autoCompleteText, axiosCancelToken).then();
        }, 500);
    }

    /**
     * Fetches the list of parts from the server based on the keywords.
     * @param keywords {string}
     * @param {import('axios').CancelTokenSource} axiosCancelToken
     */
    const getData = async (keywords, axiosCancelToken) => {
        setIsLoading(true);
        const response = await Api.getBulkPriceChangeAutoCompleteParts(keywords, axiosCancelToken.token);
        if (!isMounted())
            return;
        setIsLoading(false);
        if (response?.resultFlag) {
            setOptions(response.data ?? []);
        }
    }

    /**
     * Closes the autocomplete popper.
     *
     * - Ignores closing the popper when option is selected or is being removed
     * @param {Event} e
     * @param {import('@mui/material').AutocompleteCloseReason} reason
     */
    const onClose = (e, reason) => {
        switch (reason) {
            case "select-option":
                break;
            default:
                setOpen(false);
                setSelectedItems(selectedOptions.map(e => e.value));
                break;
        }
    }

    /**
     * Sets the [selectedOptions] state value with the provided selectedOptions form the autocomplete.
     *
     * @param event
     * @param selectedOptions
     */
    const onSelectionChanged = (event, selectedOptions) => {
        setSelectedOptions(selectedOptions);
    }


    /**
     * Removes the selected auto complete option
     */
    const removeSelectedOption = (option) => {
        setSelectedItems(selectedOptions.filter(e => !(e.value.id === option.value.id && e.value.type === option.value.type)).map(e => e.value));
    }

    /**F
     * Renders the list of options in the suggestions pop-over
     * @param option
     * @param isSelected
     * @return ReactNode
     */
    const renderOption = (option, isSelected) => {
        if (!option) return '';
        return (
            <div className={'d-flex w-100 align-items-center justify-content-between'}>
                <p className={'ml-2'}>{`${option?.value.value} ( ${option.value.type} )`}</p>
                {
                    isSelected
                        ? <CheckedBox/>
                        : <EmptyBox/>
                }
            </div>
        );
    }


    return (
        <>
            {
                selectedOptions?.length > 0 &&
                <div className={'selected-factors-wrapper'}>
                    {
                        selectedOptions?.map((option) => (
                            <Chips
                                key={`${option.value.type}-${option.value.id}`}
                                disabled={disabled}
                                className={'mr-2 mb-2'}
                                type={ChipsTypes.remove}
                                content={`${option.value.value} (${option.value.type})`}
                                onIconClick={() => removeSelectedOption(option)}
                            />
                        ))
                    }
                </div>
            }
            <div className={'auto-complete-wrapper'}>
                <OutlinedAutoComplete
                    fullWidth
                    multiple
                    clearOnBlur
                    forcePopupIcon
                    includeDefaultEndAdornment
                    freeSolo={false}
                    renderTags={() => null}
                    loading={isLoading}
                    disabled={disabled}
                    label={'Select Products'}
                    placeholder={'Part No, Tag, or Category'}
                    type={'text'}
                    variant={'outlined'}
                    value={selectedOptions ?? ''}
                    inputValue={autoCompleteText ?? ''}
                    open={open}
                    onOpen={() => setOpen(true)}
                    getOptionSelected={(option, value) => (option.value.id === value.value.id && option.value.title === value.value.title && value.value.type === option.value.type)}
                    onSelect={onSelectionChanged}
                    onOptionUnselected={onSelectionChanged}
                    onClose={onClose}
                    onChange={(e) => setAutoCompleteText(e.target.value)}
                    options={options?.map(item => ({
                        title: item.value,
                        value: item,
                    })) ?? []}
                    renderOption={(props, option, {selected}) => renderOption(option, selected)}
                    popupIcon={
                        isLoading
                            ? <CircularProgress size={25} color={'primary'}/>
                            : <></>
                    }
                    loadingText={'Loading...'}
                />
            </div>
        </>
    );
}

export default NewBulkPriceChangeViewProductSelectionAutoComplete;
